import { createContext } from "react";
const projectsContext = createContext();
export default projectsContext;